import Typography from "@mui/material/Typography";
import color from "context/MaterialUITheme/color";
import CTrackerTimelineItem, {
  trackerStatusColor,
} from "components/CTimelineItem";
import useTracker from "components/CTracker/useTrackerContext";

const TitleVerification: React.FC = () => {
  const { loan } = useTracker();
  const borrowerSteps = loan?.borrowerSteps;
  const status = borrowerSteps?.titleVerification?.status ?? "pending";
  const message = borrowerSteps?.titleVerification?.message ?? "";
  const data = borrowerSteps?.titleVerification?.data;

  return (
    <CTrackerTimelineItem
      status={status}
      title="Title"
      tooltip="Title reports are requested immediately when you apply. Sometimes it takes the county a few hours to reply, but we’ll check this box off when it’s complete."
    >
      {status === "failed" && data && (
        <Typography variant="h6" color={color.black}>
          {message}
        </Typography>
      )}
      <Typography
        variant="h6"
        color={color[trackerStatusColor[status] as keyof typeof color]}
      >
        {status === "analyzing" && (message || "Analyzing")}{" "}
        {status === "failed" && !data && message}
        {status === "failed" && data && data}
        {status === "success" && message}
      </Typography>
    </CTrackerTimelineItem>
  );
};

export default TitleVerification;
